<template>
  <span class="block-context-menu" @touchstart="start" @touchend="stop" @touchcancel="stop">
    <slot />
  </span>
</template>

<script>
export default {
  'name': 'HoldArea',
  props: {
    hold_time: {
      type: Number,
      default: 300
    }
  },
  data(){
  	return {
      interval:false,
      count: 0,
      fired: false
    }
  },
  methods: {
  	start(){
      this.fired = false
    	if(!this.interval){
      	this.interval = setInterval(() => {
          this.count++
          if(this.count >= this.hold_time && this.fired === false) {
            this.fired = true
            this.$emit('hold')
          }
        }, 1)
      }
    },
    stop(){
    	clearInterval(this.interval)
      this.interval = false
      this.count = 0
      if(this.count >= this.hold_time && this.fired === false) {
        this.fired = true
        this.$emit('hold')
      }
    }
  },
  mounted(){
    document.querySelectorAll('.block-context-menu').forEach((el) => {
        el.oncontextmenu = function(event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/HoldArea.vue